import { render } from "./AiPromptsPanel.vue?vue&type=template&id=1c49aa2f"
import script from "./AiPromptsPanel.vue?vue&type=script&lang=js"
export * from "./AiPromptsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__